// The seven existing DROP 001 studies are available even when the catalog API is paused.
// No price, inventory, or checkout details are inferred from concept images.
export const brandProducts = [
  ['scorpion-chest-tee', 'SCORPION CHEST TEE', 'tee'],
  ['scorpion-back-tee', 'SCORPION BACK TEE', 'tee'],
  ['jellyfish-hem-tee', 'JELLYFISH HEM TEE', 'tee'],
  ['snake-chest-tee', 'SNAKE CHEST TEE', 'tee'],
  ['snake-back-tee', 'SNAKE BACK TEE', 'tee'],
  ['puffer-mug', 'PUFFER MUG', 'mug'],
  ['snake-tumbler', 'SNAKE TUMBLER', 'tumbler'],
].map(([slug, name, category], index) => ({
  id: `brand-${slug}`, slug, name, category, price: null,
  drop: { name: 'DROP 001' }, purchase_url: null, payment_price_id: null,
  metadata: { previewOnly: true }, display_order: index,
}));
